import { defineStore } from 'pinia';
import { ref } from 'vue';

export type SorAnalyzeControlHandlers = {
  pause: () => void;
  resume: () => void;
  /** 软停止：中止轮询与动画，保留已写入表格的内容并落库（不回退） */
  stop: () => void | Promise<void>;
  rollback: () => Promise<void>;
};

export const useSorAnalyzeControlStore = defineStore('sorAnalyzeControl', () => {
  const handlers = ref<SorAnalyzeControlHandlers | null>(null);

  function register(next: SorAnalyzeControlHandlers) {
    handlers.value = next;
  }

  function unregister() {
    handlers.value = null;
  }

  return {
    handlers,
    register,
    unregister,
  };
});
